import script from "./GroupsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./GroupsPage.vue?vue&type=script&setup=true&lang=js"

import "./GroupsPage.vue?vue&type=style&index=0&id=59a85172&scoped=true&lang=css"

import exportComponent from "/Users/tannerwelton/Development/zulu-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59a85172"]])

export default __exports__